export default "__VITE_ASSET__D7lnWftm__"